<template>
<v-card>
  <request-status :request='req' :message200='false' />
  <request-status :request='savereq' message200='Codes have been added' />
  <v-card-title class='overline py-1 grey lighten-4' >
    <v-btn small icon @click='get' ><v-icon small >replay</v-icon></v-btn>
    Copy codes from other appointments
    <v-spacer/>
    <v-btn @click="$emit('close')" small icon ><v-icon small >close</v-icon></v-btn>
  </v-card-title>
  <v-divider/>
  <v-card-text>
    <v-card v-if='selectedIds && selectedIds.length > 0'>
      <v-card-title class='overline py-1 grey lighten-4' >
        Codes to add
        <v-spacer />
      </v-card-title>
      <v-divider/>
      <template>
        <v-card flat v-for="code in selectedItems"
          :key='code.id'
          class='ml-3' >
          <v-layout row >
            <!-- <v-flex xs1 >
              <v-icon v-if="selectedIds.indexOf(code.id) === -1" small >check_box_outline_blank</v-icon>
              <v-icon v-else small >check_box_outline</v-icon>
            </v-flex> -->
            <v-flex v-for='field in headers' :key='field.value' >
              <template v-if='field.value === "price"' >
                {{ formatCurrency(code.currency, code.price) }}
              </template>
              <template v-else >
                {{ code[field.value] }}
              </template>
            </v-flex>
          </v-layout>
          <v-divider :key="`div-${code.id}`" />
        </v-card>
        <v-checkbox dense persistent-hint
          v-model='withClear'
          label="Clear existing codes"
          hint="Will remove any codes currently on this appointment - replacing them with the copied codes"
          class="mx-2 caption mt-0" />
      </template>
      <v-divider/>
      <v-card-actions >
        <v-btn @click='clear' flat small >reset</v-btn>
        <v-spacer/>
        <v-btn small @click='save' :loading='savereq.loading' color='primary' >Save</v-btn>
      </v-card-actions>
    </v-card>
    <v-subheader class="overline" >Choose codes from previous appointments</v-subheader>
    <template v-if='!req.loading && appointments && appointments.length === 0' >
      <span class='ml-3' >Couldn't find any other appointments with codes added for this client</span>
    </template>
    <v-expansion-panel>
      <v-expansion-panel-content v-for="appt in appointments" :key="appt.id" >
        <template v-slot:header>
          {{appt.title}}. {{ dateformat(appt.start_time) }}
          <v-spacer/>
        </template>
        <template v-if='appt && appt.codes' >
          <v-card v-for="code in appt.codes"
            :key='code.id'
            class='ml-3'
            @click='toggleCode(code)' >
            <v-layout row >
              <v-flex xs1 >
                <v-icon v-if="selectedIds.indexOf(code.id) === -1" small >check_box_outline_blank</v-icon>
                <v-icon v-else small >check_box_outline</v-icon>
              </v-flex>
              <v-flex v-for='field in headers' :key='field.value' >
                <template v-if='field.value === "price"' >
                  {{ formatCurrency(code.currency, code.price) }}
                </template>
                <template v-else >
                  {{ code[field.value] }}
                </template>
              </v-flex>
            </v-layout>
            <v-divider :key="`div-${code.id}`" class='mb-2' />
          </v-card>
        </template>


          <!-- <v-data-table dense v-if='appt && appt.codes' :headers="headers" :items="appt.codes" >
            <template v-slot:items="props" >
              <td v-for='field in headers' :key='field.value' v-text='field.value' />
            </template>
          </v-data-table> -->
          <!-- <pre v-text='appt.codes' /> -->
      </v-expansion-panel-content>
    </v-expansion-panel>
    <!-- {{relationshipId}}
    <pre v-text="appointments" /> -->
  </v-card-text>
  <v-divider/>
  <v-card-actions >
    <v-btn @click='$emit("close")' flat >Cancel</v-btn>
    <v-spacer/>
    <!-- <v-btn @click='save' color='primary' >Save</v-btn> -->
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'CopyCodes',
  props: {
    appointment: { type: Object, required: false }
  },
  data () {
    return {
      withClear: false,
      req: {
        resource: 'ag.codes',
        extra: 'suggestions'
      },
      savereq: {
        resource: 'ag.codes.bulk',
        extra: 'codes'
      },
      headers: [
        { text: 'ICD-10', value: 'icd10' },
        { text: 'Process', value: 'process' },
        { text: 'Price', value: 'price' }
      ],
      selectedIds: [],
      selectedItems: []
    }
  },
  computed: {
    requestStatus () { return this.req.status },
    saveRequestStatus () { return this.savereq.status },
    appointmentId () { return this.getObjectPath(this.appointment, 'id') },
    relationshipId () { return this.getObjectPath(this.appointment, 'computed_relationship_id') },
    appointments () { return this.getObjectPath(this.req, 'result.appointments', []) },
    payload () {
      let data = {codes: this.selectedItems}
      if (this.withClear === true) {
        data['with_clear'] = true
      }
      return data
    }
  },
  watch: {
    appointmentId: {
      immediate: true,
      handler () {
        this.get()
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        this.clear()
        let vm = this
        window.setTimeout(() => {
          vm.$emit('update')
          vm.$emit('close')
        }, 100)
      }
    }
  },
  methods: {
    get () {
      this.req.params = {
        relationship_id: this.relationshipId
      }
      this.$request('get', this.req)
    },
    getNewCode (code) {
      return {
        currency: code.currency,
        icd10: code.icd10,
        nappi: code.nappi,
        order: code.order,
        price: code.price,
        process: code.process
      }
    },
    toggleCode (code) {
      let id = code.id
      let index = this.selectedIds.indexOf(id)
      if (index === -1) {
        this.selectedIds.push(id)
        this.selectedItems.push(this.getNewCode(code))
      } else {
        this.selectedIds.splice(index, 1)
        this.selectedItems.splice(index, 1)
      }
    },
    save () {
      this.savereq.resourceId = this.appointmentId
      this.savereq.data = this.payload
      this.savereq.method = 'post'
      this.$request('save', this.savereq)
    },
    clear () {
      this.selectedIds = []
      this.selectedItems = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// CopyCodes.vue?0eef76dd